/** @type {Record<string, unknown>} */
export const coreNl = {
  grain: {
    fixed: "Nerfrichting vast. Panelen niet 90° draaien",
    free: "Geen nerfrichting. Panelen mogen 90° draaien",
    noRotation: "Panelen niet 90° draaien",
  },
  strategy: {
    efficient_cutting: {
      label: "Efficiënt zagen",
      description: "Zo praktisch mogelijk zagen met zo min mogelijk onnodige zaagsnedes.",
    },
    preserve_offcuts: {
      label: "Grote zaagrest bewaren",
      description: "Waar mogelijk grote rechthoekige stukken zaagrest behouden en meegeven.",
    },
    strips: {
      label: "Stroken leveren",
      description: "Volledige stroken zagen; jij kort thuis op eindmaat af. Geschikt voor herhaalde plankbreedtes.",
    },
  },
  strip: {
    whenToUse: {
      title: "Wanneer stroken leveren?",
      body: "Als de zaagwinkel volledige stroken mag zagen (bijv. 2440 × 400 mm) en jij thuis op lengte afkort. Werkt het best als meerdere onderdelen dezelfde strookbreedte delen en er geen zaagsnede dwars door andere onderdelen hoeft.",
      example: "Voorbeeld: vier planken van 800 × 400 mm uit één strook 2440 × 400 mm.",
    },
    whenBlocked: {
      title: "Stroken niet mogelijk op deze plaat",
      body: "De strook-snede zou dwars door een ander onderdeel lopen dat op dezelfde plaat ligt. Dat is bij gemengde indelingen (bureau, kast met verschillende maten) bijna altijd zo.",
      fallback: "Gebruik efficiënt zagen of grote zaagrest bewaren. Grotere zaagmaten per onderdeel kun je handmatig in de zaaglijst zetten als je thuis wilt afwerken.",
    },
    noEligibleSheets: {
      title: "Stroken past niet bij dit project",
      body: "Geen enkele plaat heeft een eenvoudige strook-indeling. Kies efficiënt zagen als standaard.",
    },
    emptySheet: {
      title: "Lege plaat",
      body: "Deze plaat heeft geen onderdelen.",
    },
    crossesPanel: {
      horizontal: "horizontale",
      vertical: "verticale",
      unknownPart: "een onderdeel",
      message: "Een {{axis}} strook-snede (rond {{position}}) zou dwars door {{panelName}} gaan. {{body}}",
    },
  },
  offcut: {
    fullSheet: "volledige plaat",
    loose: "los zaagrest",
    rightPanel: "rechter restvlak",
    bottomPanel: "onderste restvlak",
    freeArea: "vrij restvlak",
  },
  boardLabel: {
    offcutDefault: "ZAAGREST",
    offcutSelfTrim: "ZELF AF TE KORTEN",
    stripBannerNoCrosscut: "STROKEN HEEL LEVEREN. NIET OP LENGTE AFKORTEN",
    stripBannerCrosscut: "STROKEN LEVEREN, DAARNA AFKORTEN OP ZAAGMAAT",
    placementStripSelfTrim: "ZAAGMAAT: zelf afkorten uit strook",
  },
  cutSummary: {
    singular: "{{count}} zaagsnede · {{mode}}",
    plural: "{{count}} zaagsneden · {{mode}}",
    mode: {
      strips: "stroken",
      preserve: "rest bewaren",
      efficient: "efficiënt",
    },
  },
  preview: {
    noCutsTitle: "Nog geen sneden uitgevoerd",
    noCutsDetail: "Stap door de genummerde snedes om de volgorde te controleren.",
    cutTitle: "Snede {{number}}: {{caption}}",
  },
  sheetInstruction: {
    exactPrefix: "De zaagmaten in de tabel zijn leidend. ",
    efficient: "{{prefix}}Graag efficiënt zagen met zo min mogelijk onnodige zaagsnedes. Waar mogelijk eerst lange, doorlopende zaagsneden maken.",
    preserve: "{{prefix}}Graag waar mogelijk grote rechthoekige stukken zaagrest behouden en meegeven.",
    preserveWithOffcut: "{{prefix}}Graag waar mogelijk grote rechthoekige stukken zaagrest behouden en meegeven. Potentieel bruikbaar zaagrest: circa {{size}} ({{offcutLabel}}).",
    strips: "{{prefix}}Graag eerst logische stroken zagen en deze niet op lengte afkorten. De stroken graag zo lang mogelijk meegeven; ik kort ze zelf op eindmaat.",
    stripsWithOffcuts: "{{prefix}}Graag eerst logische stroken zagen en deze niet op lengte afkorten. De stroken graag zo lang mogelijk meegeven; ik kort ze zelf op eindmaat. Verwachte restdelen na zelf afkorten per strook: {{offcutSizes}}.",
    empty: "",
  },
  rowInstruction: {
    stripDeliver: "Als strook leveren; niet op lengte afkorten. Lengte wordt zelf op maat gemaakt.",
    trimLength: "lengte later zelf inkorten van {{from}} naar {{to}}",
    trimWidth: "breedte later zelf inkorten van {{from}} naar {{to}}",
    joined: "{{parts}}",
    orderDiffers: "Bestelmaat wijkt af van eindmaat.",
    exactPreserve: "Exact zagen volgens opgegeven zaagmaat. Waar praktisch grote stukken zaagrest behouden.",
    cutPreserve: "Zagen volgens zaagmaat. Waar praktisch grote stukken zaagrest behouden.",
    exact: "Exact zagen volgens opgegeven zaagmaat.",
    cutPerSize: "Zagen volgens zaagmaat.",
    cutToSize: "Zagen op zaagmaat.",
    shortStrip: "Strook leveren; niet afkorten",
    shortExact: "Exact zagen",
    shortOrderSize: "Bestelmaat leveren",
    shortCut: "Zagen",
  },
  edge: {
    top: "boven",
    right: "rechts",
    bottom: "onder",
    left: "links",
    none: "geen",
    single: "{{side}}",
    list: "{{sides}}",
  },
  csv: {
    quantity: "Aantal",
    orderLength: "Zaagmaat lengte (mm)",
    orderWidth: "Zaagmaat breedte (mm)",
    finalLength: "Eindmaat lengte (mm)",
    finalWidth: "Eindmaat breedte (mm)",
    thickness: "Dikte (mm)",
    description: "Omschrijving",
    project: "Project",
    material: "Materiaal",
    edges: "Randen",
    sheet: "Plaat",
    instruction: "Instructie",
  },
  printSummary: {
    stripsDeliver: "Lever als volledige strook: {{sizes}}.",
    stripsDefault: "Lever als volledige stroken; niet op lengte afkorten.",
    stripsTrimTo: "Zelf af te korten naar: {{sizes}}.",
    stripsSelfCut: "Verwacht zelf af te korten: {{sizes}}.",
    preservePrimary: "Indien praktisch één primair stuk zaagrest meegeven: circa {{size}}.",
    preserveGeneric: "Indien praktisch grotere stukken zaagrest behouden en meegeven.",
    efficient: "Efficiënt zagen volgens de zaagmaten in de zaaglijst.",
  },
  unnamedPanel: "Naamloos paneel",
  unnamedProject: "Naamloos project",
  restUnused: {
    defaultLabel: "Rest {{length}} × {{width}}",
    invalid: "Vul een geldige lengte, breedte (min. {{minSize}}) en aantal in.",
    wrongThickness: "Geen onderdelen van {{thickness}} in dit plan.",
    tooSmall: "Geen onderdeel past op {{length}} × {{width}}.",
    notNeeded: "Niet gebruikt: andere platen volstaan voor deze indeling.",
  },
  errors: {
    invalidProjectFile: "Ongeldig projectbestand.",
    unsupportedProjectVersion: "Niet-ondersteunde projectversie: {{version}}.",
    missingProjectData: "Ongeldig projectbestand: geen projectdata gevonden.",
    invalidHandover: "Ongeldige projectoverdracht.",
    missingHandoverPayload: "Geen projectdata in de link.",
    unsupportedHandoverVersion: "Niet-ondersteunde overdrachtsversie: {{version}}.",
    unsupportedHandoverCodec: "Niet-ondersteunde overdrachtscode: {{codecId}}.",
    emptyHandoverPayload: "Ongeldige overdracht: lege payload.",
    utf8EncoderUnavailable: "UTF-8 encoder niet beschikbaar.",
    utf8DecoderUnavailable: "UTF-8 decoder niet beschikbaar.",
    sheetNotFound: "Plaat niet gevonden.",
  },
  stripDelivery: {
    notApplicable: "n.v.t.",
  },
};
